<template>
  <ValueHeader />
  <ValueBody />
</template>
  
<script>
  import ValueHeader from '../molecules/ValueHeader.vue'
  import ValueBody from '../molecules/ValueBody.vue'

  export default {
    name: 'ValueView',
    components: {
      ValueHeader,
      ValueBody
    }
  }
</script>